<div [formGroup]="formGroup" *ngIf="formGroup" class="w-full py-1 px-2">
  <div
    class="gap-1 items-start rounded-lg"
    [ngClass]="
      labelAbove ? 'flex flex-col' : 'grid grid-cols-12 gap-3 items-center'
    "
  >
    <!-- Label -->
    <label
      for="dropdown"
      [ngClass]="[
        labelAbove
          ? 'text-2sm font-semibold text-gray-700 dark:text-gray-300 mb-1'
          : 'col-span-4 text-2sm font-semibold text-gray-700 dark:text-gray-300 leading-tight',
        fields.isRequired ? 'required' : '',
      ]"
    >
      {{ formatDisplayName(fields.displayName) }}
    </label>
    <div [ngClass]="labelAbove ? 'relative w-full' : 'relative col-span-8'">
      <div class="custom-dropdown w-full">
        <input type="hidden" [formControlName]="fields.fieldName" />
        <!-- Selected Display -->
        <div
          #focusInput
          tabindex="0"
          class="dropdown-selected input flex items-center cursor-pointer border border-gray-300 dark:border-gray-600 rounded-md transition-all duration-150"
          [class.placeholder]="!hasSelection()"
          [class.disabled]="
            disableFields || formGroup.get(fields.fieldName)?.disabled
          "
          [ngStyle]="{
            color: hasSelection()
              ? getSelectedOptionColor(formGroup.get(fields.fieldName)?.value)
              : '#808290',
          }"
          (click)="toggleDropdown($event)"
        >
          <!-- Single Select -->
          <ng-container *ngIf="!fields.multiselect">
            {{
              formId === "6a3d163923bf07d3d695d993"
                ? selectedItem?.shortName ||
                  selectedItem?.name ||
                  selectedItem?.text ||
                  (isString(selectedItem) ? selectedItem : null) ||
                  ""
                : selectedItem?.domain && selectedItem?.fullName
                  ? selectedItem.domain + " (" + selectedItem.fullName + ")"
                  : (isArray(selectedItem)
                      ? selectedItem[0]?.role ||
                        selectedItem[0]?.name ||
                        selectedItem[0]?.text ||
                        selectedItem[0]?.label
                      : null) ||
                    selectedItem?.role ||
                    selectedItem?.text ||
                    selectedItem?.name ||
                    selectedItem?.domain ||
                    selectedItem?.label ||
                    formatPlaceholder(fields.placeholder) ||
                    "Select option"
            }}
          </ng-container>

          <!-- Multi Select -->
          <ng-container *ngIf="fields.multiselect" class="ellipsis-text">
            {{ getSelectedDisplay() }}
          </ng-container>
          <span class="arrow ms-auto" [class.open]="isOpen"></span>
        </div>

        <!-- Dropdown Panel -->
        <div
          #dropdownPanel
          [ngClass]="{
            'dropdown-up': openUpwards,
            'dropdown-down': !openUpwards,
          }"
          class="dropdown-panel bg-white dark:bg-coal-500 border border-gray-200 dark:border-gray-600 rounded-md"
          (click)="$event.stopPropagation()"
          (scroll)="onScroll($event)"
        >
          <div
            class="dropdown-option flex items-center gap-2 px-3 py-2.5 hover:bg-gray-50 dark:hover:bg-gray-700/40 cursor-pointer transition-colors duration-100"
            *ngFor="let option of filteredData"
            (click)="selectOption(option, $event)"
          >
            <!-- Checkbox for Multi -->
            <input
              *ngIf="fields.multiselect"
              type="checkbox"
              [checked]="isSelected(option)"
              class="cursor-pointer h-4 w-4 checkbox checkbox-2sm"
            />

            <div class="flex items-center w-full">
              <ng-container
                *ngIf="
                  fields?.fieldName === 'owners' ||
                    fields?.fieldName === 'assignee' ||
                    fields?.fieldName === 'assigned';
                  else defaultOption
                "
              >
                <div class="flex items-center gap-2 py-0.5">
                  <img
                    *ngIf="hasValidPhoto(option.profilePhoto)"
                    [src]="option.profilePhoto"
                    (error)="handleImageError($event)"
                    alt="Profile"
                    class="w-7 h-7 rounded-full object-cover flex-shrink-0"
                  />
                  <div
                    *ngIf="!hasValidPhoto(option.profilePhoto)"
                    class="avatar-circle flex items-center justify-center text-white text-2xs font-semibold rounded-full w-7 h-7 flex-shrink-0"
                    [style.background-color]="
                      getAvatarColor(option.name || option.text || option.label)
                    "
                  >
                    {{
                      getInitials(option.name || option.text || option.label)
                    }}
                  </div>
                  <div class="flex flex-col min-w-0">
                    <span
                      class="text-2sm font-medium leading-tight text-gray-700 dark:text-gray-300 truncate"
                      >{{ option.name || option.text || option.label }}</span
                    >
                    <span
                      class="text-xs text-gray-500 leading-tight truncate"
                      *ngIf="option.email"
                      >{{ option.email }}</span
                    >
                  </div>
                </div>
              </ng-container>

              <ng-template #defaultOption>
                <span
                  [title]="
                    option.fullName
                      ? option.domain + ' (' + option.fullName + ')'
                      : ''
                  "
                  [style.color]="
                    getColorFromAllMaps(
                      option.text || option.name || option.domain
                    )
                  "
                  class="text-sm text-gray-800"
                >
                  {{
                    formId === "6a3d163923bf07d3d695d993"
                      ? option.shortName || option.name || option.text || ""
                      : option.text
                        ? option.text
                        : option.domain
                          ? option.domain + " (" + option.fullName + ")"
                          : option.name
                            ? option.name
                            : ""
                  }}
                </span>
              </ng-template>

              <!-- ASCII / Unicode circle on right -->
              <span
                *ngIf="fields.useASCII"
                class="ms-auto flex items-center gap-1 text-base leading-none"
              >
                <ng-container *ngFor="let c of getAsciiArray(option.id)">
                  <span class="inline-block w-3 h-3 text-center">
                    {{ c }}
                  </span>
                </ng-container>
              </span>
            </div>
          </div>

          <div *ngIf="fieldsData?.length === 0" class="p-3 text-gray-500">
            Not Available
          </div>

          <div
            *ngIf="fieldsData?.length > 0 && filteredData.length === 0"
            class="p-3 text-gray-500"
          >
            No results found
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
